import { amountToDisplayValue } from '@billy/design-system'

import { Side } from '../../../../../../../enums/side'

export const formatTransactionAmount = (amount: number, side: Side, currency?: string): string =>
  `${side === Side.Debit ? '+' : '-'} ${amountToDisplayValue(amount, false, currency)}`
